import {
    SchoolListingAction,
    PUBLISH_SCHOOL_LISTING_CHANGES
} from '../actions/SchoolListingActions';
import { StoreState, SchoolListingChanges } from '../types';
import { Epic, combineEpics } from 'redux-observable';
import { createTryActionsEpic } from './Common';
import _ from 'lodash';
import { firebaseStorage, firebaseStore } from '../firebase';

const schoolSearchDoc = (schoolId: string) =>
    firebaseStore.collection('search').doc(schoolId);

const publishSchoolListing = async ({ schoolId, changes }: { schoolId: string, changes: SchoolListingChanges }, { auth }: StoreState) => {
    const user = auth.user;
    if (!user || !user.uid) {
        throw new Error('Tried to publish school listing changes without authenticating');
    }

    if (!schoolId) {
        throw new Error('Invalid schoolId');
    }

    let data: any = {};

    if (changes.description) {
        data = { ...data, description: changes.description };
    }

    if (changes.team) {
        data = {
            ...data,
            team: changes.team
        };
    }

    if (changes.tripAdvisorUrl) {
        data = { ...data, tripAdvisorUrl: changes.tripAdvisorUrl };
    }

    if (changes.logoFile && changes.logoFile.name) {
        const ext = _.last(changes.logoFile.name.split('.'));
        if (ext) {
            const ref = firebaseStorage.ref().child(`schools/${schoolId}/images/logo.${ext}`);
            await ref.put(changes.logoFile);
        }
    }

    if (changes.backgroundFile && changes.backgroundFile.name) {
        const ext = _.last(changes.backgroundFile.name.split('.'));
        if (ext) {
            const ref = firebaseStorage.ref().child(`schools/${schoolId}/images/background.${ext}`);
            await ref.put(changes.backgroundFile);
        }
    }

    if (!_.isEmpty(data)) {
        await schoolSearchDoc(schoolId).set(data, { merge: true });
    }
};

const publishSchoolListingEpic: Epic<SchoolListingAction, SchoolListingAction, StoreState> =
    createTryActionsEpic(
        PUBLISH_SCHOOL_LISTING_CHANGES,
        (a, s) => publishSchoolListing(a.value, s),
        (a, r) => a.value);

export default combineEpics<SchoolListingAction, SchoolListingAction, StoreState>(
    publishSchoolListingEpic
);
